// Recovered compiled webpack factory 60861. Edit this function expression; run npm run build.
(e, t) => {
  function r(e) {
    let { ampFirst: t = !1, hybrid: r = !1, hasQuery: n = !1 } = void 0 === e ? {} : e;
    return t || (r && n);
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "isInAmpMode", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
